// Thème et variables de style pour le site

export const theme = {
  colors: {
    primary: '#4A6741', // Vert olive foncé
    secondary: '#7D9A6A', // Vert olive moyen
    accent: '#A4BE7B', // Vert olive clair
    light: '#E5EBE0', // Vert très pâle
    dark: '#2C3E2A', // Vert très foncé
    text: '#333333', // Texte principal
    textLight: '#666666', // Texte secondaire
    background: '#F8F9F6', // Fond principal
    white: '#FFFFFF',
    black: '#000000',
    gold: '#D4AF37', // Touche dorée pour les éléments premium
  },
  fonts: {
    main: '"Playfair Display", serif', // Police élégante pour les titres
    body: '"Lato", sans-serif', // Police lisible pour le corps du texte
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '992px',
    wide: '1200px',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.1)',
    large: '0 8px 16px rgba(0, 0, 0, 0.1)',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    circle: '50%',
  },
  transitions: {
    fast: '0.2s ease',
    medium: '0.3s ease',
    slow: '0.5s ease',
  },
};
